import { useState, useLayoutEffect, useRef } from 'react';

export const useScrollPosition = () => {
  const [scrollPos, setScrollPos] = useState(0);
  const scrollRef = useRef(null);

  useLayoutEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setScrollPos(window.scrollY);
      }, 100);
    };
    scrollRef.current = handleScroll;
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);
  return scrollPos;
};
